import { request } from "./api";

/**
 * Upload a single product image to Cloudinary via the product upload endpoint.
 * Returns the full Cloudinary URL (persists in production).
 */
export async function uploadVariantImage(file) {
  if (!file) throw new Error("No file selected");

  const form = new FormData();
  form.append("file", file);

  // ✅ Use the product Cloudinary endpoint (NOT the mall/disk endpoint)
  const res = await request("/api/shop/products/upload-image", {
    method: "POST",
    body: form,
    auth: true,
  });

  const url = res?.url || res?.data?.url || "";
  if (!url) throw new Error("Upload did not return a URL");
  return url;
}
